export enum AuthPopupType {
	LOGIN = 'LOGIN',
	SIGNUP = 'SIGNUP',
	SIGNUP_COMPLETE = 'SIGNUP_COMPLETE',
	COMPLETE_CLINICIAN = 'COMPLETE_CLINICIAN',
	CONFIRM_EMAIL = 'CONFIRM_EMAIL',
}
